import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Server, Response } from "miragejs"
import axios from 'axios';
import _set from 'lodash/set';

import { makeBtStyles } from './Theme';
import { layouts } from './Layout';


let DevControls = () => null;

const url = new URL(window.location.href);
const isDevMode = url.searchParams.get('devmode');
const currentLayoutKey = url.searchParams.get('branding.layout_key') || 'layout01';
const currentThemeKey = url.searchParams.get('branding.theme_key') || 'light';
const currentMockName = url.searchParams.get('d') || 'withLinks';


const KNOWN_MOCKS = [ // List of mocks in `public/mocks`
  'australiaShipment',
  'canadaShipment',
  'delivered',
  'manyTrackingEvents',
  'missingBrandingConfig',
  'missingShipmentData',
  'missingTrackingData',
  'newZealandShipment',
  'testingMock',
  'threeLineItems',
  'ukShipment',
  'unknownCarrier',
  'voided',
  'weightRounding',
  'withLinks',
  'withLinksV1'
];

if( isDevMode || window.Cypress ) {
  const mergeUrlParamData = (responseData) => {
    let data = responseData;

    url.searchParams.forEach( (value,name) => {
      if( /(branding|shipment|tracking|notification_setting)\./.test(name) ) {
        const parsedValue = /^(true|false)$/.test(value) ? JSON.parse(value) : value;
        _set( data, name, parsedValue );
      }
    });

    return data;
  };

  let server = new Server({
    routes() {
      this.get(`${process.env.REACT_APP_API_URL}track/*`, (schema, fakeRequest) => {
        return new Promise( (resolve) => {
          const mockName = currentMockName;

          if( ! /^\w+$/.test( mockName ) ) { // Prevents URL attack. Keep simple, we can live with simple mock names
            throw new Error(`Invalid mock name '${mockName}'`);
          }

          axios.get(`/mocks/${mockName}.json`).then(
            response => resolve(
              new Response(
                response.data.status_code,
                response.data.headers,
                mergeUrlParamData(response.data.body) // body
              )
            ),
            () => { throw new Error(`No such mock '${mockName}'`); }
          );
        });
      });

      this.put(`${process.env.REACT_APP_API_URL}sms-opt-in`, (schema, fakeRequest) => {
        const { country_code, phone_number, shipment_id } = JSON.parse(fakeRequest.requestBody);

        if( country_code !== '1' ) {
          return Response( 400, {}, { message: 'Missing country_code' } );
        }
        else if( !phone_number ) {
          return Response( 400, {}, { message: 'Missing phone_number' } );
        }
        else if( phone_number === '5555555555' ) {
          console.debug(`Faking failure for + ${country_code} ${phone_number}, ${shipment_id}`);
          return new Response( 400 );
        }
        else if( phone_number === '1111111111' ) {
          console.debug(`Faking failure w/ message for ${phone_number}`);
          return new Response( 400, {}, { error_message: "That's not a real number tho!" } );
        }
        else {
          console.debug(`Subscribed + ${country_code} ${phone_number}, ${shipment_id}`);
          return new Response( 200, {}, {
            subscriptions: [
              {
                country_code: country_code,
                phone_number: phone_number,
                state: "subscribed"
              }
            ]
          });
        }
      });
    }
  });

  server.passthrough('/mocks/*');
}

if( isDevMode ) {
  const reloadWithConfig = (config) => {
    const d = config.mockName || currentMockName;
    const layout_key = config.layout_key || currentLayoutKey;
    const theme_key = config.theme_key || currentThemeKey;
    window.location = `/?devmode=1&d=${d}&branding.layout_key=${layout_key}&branding.theme_key=${theme_key}`;
  };

  const useStyles = makeBtStyles( {
    root: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      textAlign: 'right',
      background: '#eee',
      padding: '4px',
      borderRadius: '3px',
      boxShadow: '1px 1px 10px rgba(0,0,0,0.25)'
    }
  }, { name: 'dev-controls' });

  DevControls = ({ data, setData }) => {
    const classes = useStyles();

    const onChangeLayout = (layout_key) => reloadWithConfig({ layout_key });
    const onChangeTheme = (theme_key) => reloadWithConfig({ theme_key });
    const onChangeMock = (mockName) => reloadWithConfig({ mockName });

    window.devMode = {
      ...(window.devMode || {}),
      data,
      setData
    };

    return <div className={classes.root}>
      <Select value={currentThemeKey} onChange={(e) => onChangeTheme(e.target.value)}>
        { ['light', 'dark', 'peach', 'unicorns'].map( theme_key =>
          <MenuItem value={theme_key} key={theme_key}>{theme_key}</MenuItem>
        )}
      </Select>
      <br />
      <Select value={currentLayoutKey} onChange={(e) => onChangeLayout(e.target.value)}>
        { Object.keys(layouts).map( layout_key =>
          <MenuItem value={layout_key} key={layout_key}>{layout_key}</MenuItem>
        )}
      </Select>
      <br />
      <Select value={currentMockName} onChange={(e) => onChangeMock(e.target.value)}>
        { KNOWN_MOCKS.map( mockName =>
          <MenuItem value={mockName} key={mockName}>{mockName}</MenuItem>
        )}
      </Select>
    </div>;
  }
}

export default DevControls;